import { render } from "./BottomMenu.vue?vue&type=template&id=5f9b16ea&scoped=true"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=5f9b16ea&lang=scss&scoped=true"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9b16ea"]])

export default __exports__